// @flow

import * as React from 'react';
import { connect } from 'react-redux';

type ExternalProps = {|
  /** The component to be hidden in readonly */
  children: React.Node,
  /** Optional. In readonly mode, instead of hiding, show this component instead (e.g. a message to the user) */
  replaceWith?: React.Node,
|};

type Props = {|
  /** Refer to the JSDocs above for ExternalProps */
  ...ExternalProps,
  /** From Redux */
  isReadonlyMode: boolean,
|};

/**
 * Hide the children in readonly mode (i.e. during failover)
 * Optionally replace with another component
 *
 * @author amoosavi
 * @since Nov 2018
 */

// Visible for storybook only. Do not use directly
export const HideOnReadonlyWithoutRedux = ({ isReadonlyMode, replaceWith, children }: Props) => {
  if (isReadonlyMode) {
    if (replaceWith !== undefined) {
      return replaceWith;
    }
    return null;
  }
  return children;
};

export default connect<Props, ExternalProps, _, _, _, _>(redux => ({
  isReadonlyMode: redux.meta.readonlyMode,
}))(HideOnReadonlyWithoutRedux);
